import { createSelector } from 'reselect';

const selectCatalogSettings = (state: any) => state.catalogSettings;


export const selectCatalogSettingsCurrentItem = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.current);

export const selectCatalogSettingsListItems = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.list);

export const selectCatalogSettingsItemById = (itemId: any) =>
    createSelector(selectCatalogSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCatalogSettingsQueryItems = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.query);

export const selectCatalogSettingsCreatedItem = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.create);

export const selectCatalogSettingsUpdatedItem = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.update);

export const selectCatalogSettingsReadItem = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.read);

export const selectCatalogSettingsDeletedItem = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.delete);

export const selectCatalogSettingsSearchedItems = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.search);

export const selectCatalogSettingsItemsCount = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.count);

export const selectCatalogSettingsItemsFilter = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.filter);

export const selectCatalogSettingsSummaryItems = createSelector([selectCatalogSettings], (catalogSettings) => catalogSettings.summary);